var exports = {
  "Nr": "PremiumSubscriptionCard.module__card___VDdEdH" + " " + __webpack_require__(367917)["LU"],
  "d5": "PremiumSubscriptionCard.module__head___VDdEdH",
  "DD": "PremiumSubscriptionCard.module__title___VDdEdH",
  "h5": "PremiumSubscriptionCard.module__status___VDdEdH",
  "hU": "PremiumSubscriptionCard.module__statusWarning___VDdEdH" + " " + "PremiumSubscriptionCard.module__status___VDdEdH",
  "Ge": "PremiumSubscriptionCard.module__rows___VDdEdH",
  "nM": "PremiumSubscriptionCard.module__row___VDdEdH",
  "N4": "PremiumSubscriptionCard.module__note___VDdEdH",
  "LV": "PremiumSubscriptionCard.module__paymentLink___VDdEdH" + " " + __webpack_require__(560740)["button"] + " " + __webpack_require__(560740)["secondary"] + " " + __webpack_require__(560740)["small"],
  "o1": "PremiumSubscriptionCard.module__actions___VDdEdH",
};

module.exports = exports;
